module.exports = __webpack_public_path__ + "assets/svg/Icons/32/pages-gray-3d989f.svg";